import MuiCardContent, { CardContentProps } from "@mui/material/CardContent";

const CardContent: React.FC<CardContentProps> = MuiCardContent;

export default CardContent;
export type { CardContentProps };
